import { z } from 'zod'

export const instrumentDetailSchema = z.object({
  uid: z.string(),
  figi: z.string(),
  ticker: z.string(),
  name: z.string(),
  instrumentType: z.string(),
  currency: z.string(),
  lot: z.number().int(),
  exchange: z.string(),
  countryOfRisk: z.string(),
  sector: z.string().nullable(),
  classCode: z.string(),
  tradingStatus: z.number().int(),
  tradingStatusName: z.string(),
  apiTradeAvailableFlag: z.boolean(),
  buyAvailableFlag: z.boolean(),
  sellAvailableFlag: z.boolean(),
  maturityDate: z.string().nullable(),
  nominal: z.number().nullable(),
})
export type InstrumentDetailDto = z.infer<typeof instrumentDetailSchema>
